import { html } from 'lit';
import { Subscription } from '@common/types/model.js';
import { formatMsisdn } from '@common/utils/MobilePhoneNumber.js';
import type { TefComs4cs4p } from '@src/components/TefComs4cs4p.js';

//
// renders a single subscription block
//
// {subscription msisdn}
//   {app consent BLOCK}
//
export const singleSubscription = function render(this: TefComs4cs4p, subscription : Subscription)
  : ReturnType<typeof html> {
  return html`
    <section class="section section--prio-bg-2 section--size-flat u-block-centered">
      <div class="typography-display--6 u-sb--flat" align="center">
        <a data-testid="filter-by-subscription-link" data-subscription-id="${subscription.msisdn}" @click="${this.handleFilterMsisdn}">${formatMsisdn(subscription.msisdn)}
          <tef-icon icon="filter" size="0.8" type="functional"></tef-icon>
        </a>
      </div>
    </section>

    <div class="container">
      ${subscription.apps.map((app) => this.getTemplateFn('singleAppConsent')(app))}
    </div>`;
};
